<template>
  <div id="app-container">
    <transition name="fade">
      <router-view></router-view>
    </transition>
    <cookie-alert id="cookie-alert" />
  </div>
</template>

<script>
import CookieAlert from '@/components/app/CookieAlert'

export default {
  name: "App",
  components: {
    CookieAlert
  }
}
</script>

<style lang="scss">
@import "./sass/main";

#app-container {
  width: 100%;
  height: 100vh;
}

#cookie-alert {
  position: fixed;
  top: 100vh;
  margin-top: -80px;
  left: 0;
  right: 0;
  min-height: 80px;
  z-index: 1010;
}
</style>



// WEBPACK FOOTER //
// src/App.vue